import React from 'react';
import {createRoot} from 'react-dom/client'

import MenuDropdownStandalone from '../components/staff/menu-dropdown-standalone'

// Polyfill for Object.assign (IE)
if (typeof Object.assign !== 'function') {
  Object.assign = function (target) {
    'use strict';
    if (target == null) {
      throw new TypeError('Cannot convert undefined or null to object');
    }

    target = new Object(target);
    for (let index = 1; index < arguments.length; index++) {
      const source = arguments[index];
      if (source != null) {
        for (const key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
    }

    return target;
  };
}

global.$(() => {
  const standaloneMenuDiv = document.querySelector('#standaloneMenuDropdown');
  if (standaloneMenuDiv) {
    createRoot(standaloneMenuDiv).render(<MenuDropdownStandalone />);
  }
});
